import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ConfirmationModal } from 'seagull';
import { isUrlValid } from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVIdeoModal.utils';
import { isStatusSuccess } from '~/components/VideoPlayer/VideoPlayer';
import { useLocaleKeys } from '~/i18n';
import IntroVideoModalContent from './IntroVideoModalContent';
const IntroVideoModal = (param)=>{
    let { dismissModal, onSave, videoLink } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio.introVideo');
    const { t: commonTexts } = useLocaleKeys('common');
    const form = useForm({
        mode: 'all',
        defaultValues: {
            videoLink: videoLink || ''
        }
    });
    const [inputVideoName, setInputVideoName] = useState('');
    const [videoPlayableStatus, setVideoPlayableStatus] = useState();
    const onSubmit = ()=>{
        const inputVideoLink = form.getValues('videoLink');
        if (isUrlValid(inputVideoLink) && isStatusSuccess(videoPlayableStatus)) {
            onSave(inputVideoName, inputVideoLink);
            dismissModal();
        }
    };
    const onCancel = ()=>{
        dismissModal();
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        testId: "intro-video-modal",
        textAlignCenter: false,
        title: texts.modalTitle(),
        secondaryButtonTestId: "intro-video-modal-cancel-button",
        onSecondaryButtonClick: onCancel,
        primaryButtonTestId: "intro-video-modal-save-button",
        onPrimaryButtonClick: onSubmit,
        onCloseButtonClick: onCancel,
        primaryButtonLabel: commonTexts.buttons.save(),
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        content: /*#__PURE__*/ _jsx(IntroVideoModalContent, {
            form: form,
            setInputVideoName: setInputVideoName,
            setVideoPlayableStatus: setVideoPlayableStatus,
            videoPlayableStatus: videoPlayableStatus
        })
    });
};
export default IntroVideoModal;
